"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsLoading = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _dmsbasereact = require("dmsbasereact");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * DmsLoading component
 * 
 * @param {object} props - Component props
 * @param {boolean} props.show - Controls the visibility of the loading modal (default: false)
 * @param {number} props.timeoutTime - Time in milliseconds before showing the timeout message (default: 10000)
 * @param {string} props.timeoutMessage - Message to display when timeout occurs
 * @param {function} props.onClose - Function to call when the modal is closed (e.g., when the Cancel button is clicked)
 * @returns {JSX.Element} The rendered loading modal component
 * 
 * Example Usage:
 * 
 * const MyComponent = () => {
 *   const [isLoading, setIsLoading] = useState(false);
 * 
 *   const handleStartLoading = () => setIsLoading(true);
 *   const handleStopLoading = () => setIsLoading(false);
 * 
 *   return (
 *     <div>
 *       <button onClick={handleStartLoading}>Start Loading</button>
 *       <DmsLoading
 *         show={isLoading}
 *         timeoutTime={15000}
 *         timeoutMessage="Custom timeout message after 15 seconds."
 *         onClose={handleStopLoading}
 *       />
 *     </div>
 *   );
 * };
 */

const DmsLoading = _ref => {
  let {
    show = false,
    timeoutTime = 10000,
    timeoutMessage = _reactIntlUniversal.default.get("LoadingTimeoutMessage").d("Great things take time! Please be patient while we ensure everything is perfect."),
    onClose = () => {}
  } = _ref;
  const [timeOut, setTimeOut] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    let timer = null;
    if (show) {
      timer = setTimeout(() => {
        if (show) {
          setTimeOut(true);
        }
      }, timeoutTime);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [show, timeoutTime]);
  const handleClose = () => {
    setTimeOut(false);
    onClose();
  };
  return /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsModal, {
    isVisible: show,
    onClose: handleClose,
    fullWidth: true,
    showCloseIcon: false
  }, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsModal.Header, {
    title: _reactIntlUniversal.default.get("PleaseWait").d("Please wait")
  }), /*#__PURE__*/_react.default.createElement(_material.Divider, {
    style: {
      width: '100%'
    }
  }), /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsModal.Body, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 2
  }, timeOut && /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    style: {
      fontWeight: 'bold'
    }
  }, _reactIntlUniversal.default.get("TakingLongerMessage").d("It is taking longer than expected")), /*#__PURE__*/_react.default.createElement(_material.Typography, null, timeoutMessage)), /*#__PURE__*/_react.default.createElement(_material.CircularProgress, {
    color: "primary"
  })), timeOut && /*#__PURE__*/_react.default.createElement(_material.Divider, {
    style: {
      width: '100%',
      marginTop: '16px'
    }
  })), timeOut && /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsModal.Footer, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsButton, {
    variant: "contained",
    color: "secondary",
    onClick: handleClose
  }, _reactIntlUniversal.default.get("Cancel").d("Cancel")))));
};
exports.DmsLoading = DmsLoading;
DmsLoading.propTypes = {
  show: _propTypes.default.bool,
  timeoutTime: _propTypes.default.number,
  timeoutMessage: _propTypes.default.string,
  onClose: _propTypes.default.func
};